// extracted by mini-css-extract-plugin
export default {"black_bg":"resetMobile_black_bg_YyoMJ"};